/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useState } from "react";
import TextInput from "../common/textInput/TextInput";
import Adornment from "../common/textInput/Adornment";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import GridContainer from "../common/grid/GridContainer";
import GridItem from "../common/grid/GridItem";
import { DEBI_NEW_FORM } from "../../utils/constants/GlobalFormConstants";
import ButtonLayout from "../common/button/ButtonLayout";
import DataTable from "../common/dataTable/DataTable";
import DataList from "../common/dataList/DataList";
import DialogView from "../common/dialogView/DialogView";
import { LOOKUP_LABEL, LABEL_MAP,SOURCE, HEIGHT_30PX, VALIDATION_MSG_STYLE1 } from "../../utils/constants/GlobalConstants";
import { createDebiValidation } from "../../utils/helpers/Validation";
import Typo from "../common/typo/Typo";
import { useMediaQuery, useTheme } from "@mui/material";
import { getDCList } from "../../services/DCServices";
import SimpleSnackbar from "../common/snackbar/Snackbar";
import SimpleBackdrop from "../common/backdrop/Backdrop";
import { getStoreListFromDCId } from "../../services/StoreServices";
import { useNavigate } from "react-router-dom";
import { createDebi } from "../../services/debiServices";
import { getUserEmail, getUserName } from "../../services/userService"

const getFieldLabel = (key) => {
  const labelMap = {
    disCenter: LABEL_MAP.DIS_CENTER,
    store: LABEL_MAP.STORE,
    dealerNum: LABEL_MAP.DEALER_NUM,
    bName: LABEL_MAP.BNAME,
    tel: LABEL_MAP.TEL,
    streetAddress: LABEL_MAP.STREET_ADDRESS,
    installerEmail: LABEL_MAP.INSTALLER_EMAIL,
    city: LABEL_MAP.CITY,
    state: LABEL_MAP.STATE,
    zipcode: LABEL_MAP.ZIPCODE,
  };
  return labelMap[key] || key;
};

const CreateDebiForm = () => {
  const [open, setOpen] = React.useState(false);
  const [searchClickedFrom, setSearchClickedFrom] = React.useState("");
  const [selected, setSelected] = React.useState({ index: null, record: null });
  const [selectedDc, setSelectedDc] = React.useState({
    index: null,
    record: { name: "", city: "" },
  });
  const [selectedStore, setSelectedStore] = React.useState({
    index: null,
    record: { name: "", storeName: "" },
  });
  const [selectedDcValue, setSelectedDcValue] = React.useState("");
  const [selectedStoreValue, setSelectedStoreValue] = React.useState("");
  const [enableBtn, setEnableBtn] = React.useState(false);
  const [showDcCloseIcon, setDcShowCloseIcon] = React.useState(false);
  const [showStoreCloseIcon, setStoreShowCloseIcon] = React.useState(false);
  const [loader, setLoader] = useState(false);
  const [apiError, setApiError] = useState({ val: false, messages: "" });
  const [rowsDC, setRowsDC] = useState(null);
  const [rowsStore, setRowsStore] = useState(null);
  const [searchedData, setSearchedData] = useState();
  const [setDebiInfo] = useState(null);
  const [storeDisabled, setStoreDisabled] = useState(true);
  const navigate = useNavigate();
  const [createDebiInputs, setDebiInputs] = React.useState({
    disCenter: "",
    store: "",
    dealerNum: "",
    bName: "",
    tel: "",
    streetAddress: "",
    installerEmail: "",
    city: "",
    state: "",
    zipcode: "",
  });
  const [validationMsgs, setValidationMsgs] = React.useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = () => {
    setOpen(false);
  };

  const handleChecked = (e, record, index) => {
    if (selected && selected.index === index) {
      setEnableBtn(false);
      setSelected({ index: null, record: null });
      searchClickedFrom === LABEL_MAP.STORE
        ? setSelectedStore({ index: null, record: null })
        : setSelectedDc({ index: null, record: null });
    } else {
      setEnableBtn(true);
      setSelected({ index, record });
      searchClickedFrom === LABEL_MAP.STORE
        ? setSelectedStore({ index, record })
        : setSelectedDc({ index, record });
    }
  };
  const handleAction = (e) => {
    if (e === "select") {
      searchClickedFrom === LABEL_MAP.STORE
        ? setSelectedStoreValue(selectedStore.record.name)
        : setSelectedDcValue(selectedDc.record.name);
      searchClickedFrom === LABEL_MAP.STORE
        ? setStoreShowCloseIcon(true)
        : setDcShowCloseIcon(true);
      searchClickedFrom === LABEL_MAP.STORE
        ? setValidationMsgs((prev) =>
          prev.filter((msg) => !msg.includes(LABEL_MAP.STORE))
        )
        : setValidationMsgs((prev) =>
          prev.filter((msg) => !msg.includes(LABEL_MAP.DIS_CENTER))
        );
      setStoreDisabled(false);
    } else if (e === "remove") {
      searchClickedFrom === LABEL_MAP.STORE ? setSelectedStore("") : setSelectedDc("");
      searchClickedFrom === LABEL_MAP.STORE
        ? setSelectedStoreValue("")
        : setSelectedDcValue("");

      if (searchClickedFrom !== LABEL_MAP.STORE) {
        setSelectedStoreValue("");
        setStoreShowCloseIcon(false);
        setSelectedStore("");
        setStoreDisabled(true);
      }
    }
    handleClose();
    setSearchedData("");
  };
  const handleSearch = (val) => {
    setSearchedData(val);
  };
  const handleChange = (e, key) => {
    const value = e.target.value;
    setDebiInputs((inputs) => ({ ...inputs, [key]: value }));
    let tempMsg = createDebiValidation({ [key]: value });
    setValidationMsgs((prev) =>
      prev.filter((msg) => !msg.includes(getFieldLabel(key))).concat(tempMsg)
    );
  };

  const handleSubmit = async () => {
    let temp = {
      ...createDebiInputs,
      disCenter: selectedDcValue,
      store: selectedStoreValue,
    };
    let formValidationMsgs = createDebiValidation(temp);
    setValidationMsgs(formValidationMsgs);
    if (formValidationMsgs.length === 0) {
      let response;
      setLoader(true);
      const payload = {
        distributionCenter: temp.disCenter,
        store: temp.store,
        businessName: temp.bName,
        installerStreetAddress: temp.streetAddress,
        installerEmail: temp.installerEmail,
        installerCity: temp.city,
        installerState: temp.state,
        telephone: temp.tel,
        zipCode: temp.zipcode,
        dealerNumber: temp.dealerNum,
        salesRepEmail: getUserEmail(),
        salesRepName: getUserName(),
        createdBy: getUserName(),
      };
      setLoader(true);
      try {
        response = await createDebi(payload);
        setDebiInfo(response?.debiDTO);
        setLoader(false);
      } catch (error) {
        console.log(error,"error");
        setApiError((val) => ({ ...val, val: true, message: error?.response?.data?.error?.message ? error?.response?.data?.error?.message : error?.response?.data?.message }));
        setLoader(false);
      }
      if (response?.id) {
        navigate(
          `/debi-tool/details/${response?.debiDTO?.debiRegistrationNumber}`,
          { state: response?.id }
        );
      }
    }
  };

  const checkMsg = (label) => {
    return validationMsgs.map((item, key) => {
      if (item.includes(label))
        return (
          <Typo
            key={(key + 1) * 423}
            variant="body2"
            text={item}
            color="secondary"
            sx={{ color: "red" }}
          />
        );
    });
  };

  const DCList = async () => {
    setLoader(true);
    try {
      const response = await getDCList();
      setRowsDC(response?.distributionCenters);
      
      setLoader(false);
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };

  const storeList = async () => {
    setLoader(true);
    try {
      const DCId = 
      rowsDC?.find(
        (dc) => dc.distributionCenterName === selectedDc.record.name
      );
      let response = await getStoreListFromDCId(DCId);
      setRowsStore(response?.stores);
      
      setLoader(false);
    } catch (error) {
      setRowsStore([]);
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };
  const searchIconStyles = storeDisabled ? { pointerEvents: "none" } : {};
  return (
    <>
      <SimpleBackdrop open={loader} />

      <DialogView
        open={open}
        handleClose={() => {
          handleClose();
          setSearchedData("");
        }}
        width={isMobile ? "75%" : "53%"}
        maxWidth={"75em!important"}
        heading={LOOKUP_LABEL}
        enableBtn={enableBtn}
        testid="lookup-records-popup"
        handleAction={handleAction}
        handleSearch={handleSearch}
        childComponet={
          isMobile ? (
            <DataList
              searchedData={searchedData}
              selected={
                searchClickedFrom === LABEL_MAP.STORE ? selectedStore : selectedDc
              }
              handleChecked={handleChecked}
              source={searchClickedFrom === LABEL_MAP.STORE ? SOURCE.STORE : SOURCE.DC}
              rows={searchClickedFrom === LABEL_MAP.STORE ? rowsStore : rowsDC}
              flag="createDebi"
            />
          ) : (
            <DataTable
              searchedData={searchedData}
              selected={
                searchClickedFrom === LABEL_MAP.STORE ? selectedStore : selectedDc
              }
              testid="table"
              handleChecked={handleChecked}
              source={searchClickedFrom === LABEL_MAP.STORE ? SOURCE.STORE : SOURCE.DC}
              rows={searchClickedFrom === LABEL_MAP.STORE ? rowsStore : rowsDC}
              flag="createDebi"
            />
          )
        }
      />

      <div className="form-layout">
        <GridContainer spacing={2}>
          {DEBI_NEW_FORM.map((data, key) => {
            return (
              <GridItem xs={12} sm={4} lg={4} md={4} xl={4} key={key}>
                {data.icon && (
                  <>
                    <div style={HEIGHT_30PX}>
                      <TextInput
                        label={data.label}
                        required={true}
                        value={
                          data.label === LABEL_MAP.STORE
                            ? selectedStoreValue
                            : selectedDcValue
                        }
                        disabled={data.label === LABEL_MAP.STORE && storeDisabled}
                        InputProps={{
                          endAdornment: (
                            <Adornment>
                              {(data.label === LABEL_MAP.STORE &&
                                selectedStoreValue &&
                                showStoreCloseIcon) ||
                                (data.label === LABEL_MAP.DIS_CENTER &&
                                  selectedDcValue &&
                                  showDcCloseIcon) ? (
                                <CloseIcon
                                  sx={{ marginRight: "10px" }}
                                  testid="close"
                                  onClick={() => {
                                    if (data.label === LABEL_MAP.STORE) {
                                      setSelectedStoreValue("");
                                      setStoreShowCloseIcon(false);
                                      setSelectedStore("");
                                    } else if (
                                      data.label === LABEL_MAP.DIS_CENTER
                                    ) {
                                      setSelectedDcValue("");
                                      setDcShowCloseIcon(false);
                                      setStoreShowCloseIcon(false);
                                      setSelectedDc("");
                                      setStoreDisabled(true);
                                      setSelectedStore("");
                                      setSelectedStoreValue("");
                                    }
                                  }}
                                />
                              ) : null}

                              {data.label !== LABEL_MAP.STORE ? (
                                <SearchIcon
                                  testid="search-icon"
                                  onClick={() => {
                                    DCList();
                                    setEnableBtn(
                                      data.label !== LABEL_MAP.STORE &&
                                        selectedDc?.record?.name
                                        ? true
                                        : false
                                    );
                                    setSearchClickedFrom(data.label);
                                    setOpen(true);
                                  }}
                                />
                              ) : (
                                <SearchIcon
                                  color={storeDisabled ? "disabled" : ""}
                                  testid="search-icon1"
                                  sx={searchIconStyles}
                                  onClick={() => {
                                    storeList();
                                    setEnableBtn(
                                      data.label === LABEL_MAP.STORE &&
                                        selectedStore?.record?.name
                                        ? true
                                        : false
                                    );
                                    setSearchClickedFrom(data.label);
                                    setOpen(true);
                                  }}
                                />
                              )}
                            </Adornment>
                          ),
                        }}
                      />
                    </div>

                    <div
                      style={VALIDATION_MSG_STYLE1}
                    >
                      {validationMsgs &&
                        validationMsgs.length > 0 &&
                        checkMsg(data.label)}
                    </div>
                  </>
                )}
                {!data.icon && (
                  <>
                    <div style={HEIGHT_30PX}>
                      <TextInput
                        testid="debi-inputs"
                        datatestid={data.label}
                        label={data.label}
                        required={true}
                        value={createDebiInputs[data.key]}
                        inputProps={ data.key === "dealerNum" && {maxLength: 20 }}
                        onChange={(e) => handleChange(e, data.key)}
                      />
                    </div>
                    <div
                      style={
                        VALIDATION_MSG_STYLE1}
                    >
                      {validationMsgs &&
                        validationMsgs.length > 0 &&
                        checkMsg(data.label)}
                    </div>
                  </>
                )}
              </GridItem>
            );
          })}
        </GridContainer>
        <div className="section-b-gap">
          <ButtonLayout
            testid="save"
            color="primary"
            label="Save"
            onClickBtn={() => handleSubmit()}
          />
        </div>
      </div>
      <SimpleSnackbar apiError={apiError} />
    </>
  );
};

export default CreateDebiForm;
